<template>
  <div>
    <div class="plan-upgrade-after__value">{{ value }}</div>
    <div class="plan-upgrade-after__caption">{{ $tc(type,value,{value}) }}</div>
  </div>
</template>

<script>
export default {
  name: 'UpgradePaymentQuota',
  props: {
    type: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.plan-upgrade-after {
  &__value {
    display: inline-block;
    background: #FFFFFF;
    border-radius: 0.5rem;
    padding: 0.625rem 0.875rem;
    font-size: 1.5rem;
    line-height: 1.1;
    color: #091A35;
    margin-bottom: 0.375rem;
  }
  &__caption {
    text-align: center;
    font-size: 0.75rem;
    line-height: 1.25;
    color: rgb(9 26 53 / 50%);
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .plan-upgrade-after {
    &__value {
      padding: 0.5625rem 0.75rem;
      font-size: 1.125rem;
      line-height: 1.15;
      margin-bottom: 0.25rem;
    }
    &__caption {
      font-size: 0.6875rem;
      line-height: 1.1;
    }
  }
}
</style>

<i18n locale="ru" lang="yml">
interviews: 'отклик | отклика | откликов'
sms: 'SMS'
calls: 'звоноков | звонок | звонка | звонков'
</i18n>

<i18n locale="en" lang="yml">
interviews: 'interview | interviews | interviews'
sms: 'text message | text messages | text messages'
calls: 'calls | call | calls'
</i18n>
